import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "free-vip-tip-dialog-content" }
const _hoisted_2 = { class: "free-vip-tip-dialog-title" }
const _hoisted_3 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/vip_level_tip/tip_2c.png",
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/vip_level_tip/tip_2b.png",
  alt: ""
}
const _hoisted_5 = { style: {"padding-right":"25px"} }
const _hoisted_6 = { class: "free-vip-tip-part1" }
const _hoisted_7 = { class: "free-vip-part1-top" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "今回のご注文手数料が", -1)
const _hoisted_9 = { class: "free-vip-part1-price" }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "元おトク", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "になります。", -1)
const _hoisted_13 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/vip_level_tip/card_2c.png",
  alt: "",
  class: "part1-bg"
}
const _hoisted_14 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/vip_level_tip/card_2b.png",
  alt: "",
  class: "part1-bg"
}
const _hoisted_15 = { class: "free-vip-tip-part2" }
const _hoisted_16 = { class: "part2-left" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "現在のプラン", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text1" }, "フリープラン", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text2" }, "手数料", -1)
const _hoisted_20 = { class: "price" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "元", -1)
const _hoisted_22 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/vip_level_tip/arrow_2c.png",
  alt: "",
  class: "arrow-img"
}
const _hoisted_23 = {
  key: 1,
  src: "https://static-jp.theckb.com/static-asset/client/vip_level_tip/arrow_2b.png",
  alt: "",
  class: "arrow-img"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "変更後", -1)
const _hoisted_25 = { class: "text1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text2" }, "手数料", -1)
const _hoisted_27 = { class: "price" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "元", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "fee-vip-tip-part3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://static-jp.theckb.com/static-asset/client/vip_level_tip/warning.png",
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "ご注意")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("div", null, "ご注文確定後にプランを変更しても、"),
    /*#__PURE__*/_createElementVNode("div", null, "確定済みの手数料差額は返金対象外となります。")
  ])
], -1)

import { getWarehouseCode, isD2C, useRtfix } from '@/store'
import { ref } from 'vue'
import { nonMemberFeeCompareApi, historyMemberFeeCompareApi } from '@/apis/shopcart'
import { isFirstPayVipApi } from '@/apis/usercenter'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  emits: ['createOrder'],
  setup(__props, { expose, emit: emits }) {

const router = useRouter()

const [getConfig, setConfig] = useUserConfig(ENUM_CONFIG_CODE.FREE_VIP_LEVEL_DIALOG)
const [getConfig2, setConfig2] = useUserConfig(ENUM_CONFIG_CODE.HISTORY_VIP_LEVEL_DIALOG)
const dialogVisible = ref(false)
const handleClose = () => {
  dialogVisible.value = false
}
const againCreateOrder = async () => {
  if (isNewVip.value) {
    await setConfig('1')
  } else {
    await setConfig2('1')
  }
  dialogVisible.value = false
  emits('createOrder')
}
const priceInfo: any = ref({})
const jumpVip = async () => {
  if (isNewVip.value) {
    await setConfig('1')
  } else {
    await setConfig2('1')
  }
  router.push(useRtfix('VipLevel'))
}
const isNewVip = ref(false)
expose({
  open: async (list: any) => {
    const resData = await isFirstPayVipApi({})
    isNewVip.value = !resData.data
    const api = !resData.data ? nonMemberFeeCompareApi : historyMemberFeeCompareApi
    const result = await api({
      productParam: list.skuList,
      warehouseCode: getWarehouseCode(),
      orderType: 2,
      overseasInvFlag: 0
    })
    priceInfo.value = result?.data ?? {}
    if (!!result.data?.nonMemberFeePrice && result.data?.nonMemberFeePrice > result.data?.memberFeePrice) {
      dialogVisible.value = true
      return true
    }
    return false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    "before-close": handleClose,
    "custom-class": "free-vip-tip-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(isNewVip.value ? 'プラン変更で手数料がおトクになります' : '以前のプランなら、今回の手数料が安くなります'), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, _toDisplayString(isNewVip.value ? 'スタンダードプランに変更すると、' : '以前ご利用のプランに戻すと、'), 1),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(Number((priceInfo.value.nonMemberFeePrice - priceInfo.value.memberFeePrice).toFixed(2))), 1),
            _hoisted_11,
            _hoisted_12
          ]),
          (_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : (_openBlock(), _createElementBlock("img", _hoisted_14))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createTextVNode(_toDisplayString(priceInfo.value.nonMemberFeePrice) + " ", 1),
              _hoisted_21
            ])
          ]),
          (_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("img", _hoisted_22))
            : (_openBlock(), _createElementBlock("img", _hoisted_23)),
          _createElementVNode("div", {
            class: _normalizeClass(["part2-right", _unref(isD2C)() ? 'd2c' : ''])
          }, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(isNewVip.value ? 'スタンダードプラン' : '以前のプラン'), 1),
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createTextVNode(_toDisplayString(priceInfo.value.memberFeePrice) + " ", 1),
              _hoisted_28
            ])
          ], 2)
        ]),
        _hoisted_29,
        _createElementVNode("div", { class: "fee-vip-tip-btn" }, [
          _createElementVNode("div", {
            class: "btn1",
            onClick: againCreateOrder
          }, "このまま注文する"),
          _createElementVNode("div", {
            class: "btn2",
            onClick: jumpVip
          }, "プラン変更へ進む")
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})